import React, { useEffect, useMemo, useState } from 'react'
import '../styles/Hero.css'
import heroImage from '../assets/hero-software.jpg'
import { useTranslation } from '../context/LanguageContext.jsx'

const TYPE_MS = 72
const DELETE_MS = 42
const HOLD_MS = 1800
const GAP_MS = 380

const Hero = () => {
  const { t, dict, language } = useTranslation()
  const phrases = useMemo(() => dict.hero?.rotating ?? [], [dict.hero?.rotating, language])
  const [phraseIndex, setPhraseIndex] = useState(0)
  const [display, setDisplay] = useState('')
  const [deleting, setDeleting] = useState(false)
  const [reduceMotion, setReduceMotion] = useState(false)

  useEffect(() => {
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)')
    const sync = () => setReduceMotion(mq.matches)
    sync()
    mq.addEventListener('change', sync)
    return () => mq.removeEventListener('change', sync)
  }, [])

  useEffect(() => {
    setDisplay('')
    setDeleting(false)
    setPhraseIndex(0)
  }, [language])

  useEffect(() => {
    if (!phrases.length) return undefined
    if (reduceMotion) {
      setDisplay(phrases[0])
      return undefined
    }

    const full = phrases[phraseIndex] ?? ''
    let timer

    if (!deleting && display === full) {
      timer = setTimeout(() => setDeleting(true), HOLD_MS)
    } else if (deleting && display === '') {
      timer = setTimeout(() => {
        setDeleting(false)
        setPhraseIndex((i) => (i + 1) % phrases.length)
      }, GAP_MS)
    } else if (deleting) {
      timer = setTimeout(() => setDisplay(full.slice(0, display.length - 1)), DELETE_MS)
    } else {
      timer = setTimeout(() => setDisplay(full.slice(0, display.length + 1)), TYPE_MS)
    }

    return () => clearTimeout(timer)
  }, [display, deleting, phraseIndex, phrases, reduceMotion])

  const fullAnnouncement = phrases.length
    ? `${t('hero.prefix')} ${phrases.join(', ')}`
    : t('hero.prefix')

  return (
    <section id="home" className="hero">
      <div className="hero-media" aria-hidden="true">
        <img src={heroImage} alt="" className="hero-media-frame is-active" />
        <div className="hero-veil" />
      </div>

      <div className="hero-layout">
        <div className="hero-brand">
          <p className="hero-brand-name">Deverse</p>
          <h1 className="hero-motto">
            <span className="hero-motto-static">{t('hero.prefix')}</span>{' '}
            <span className="hero-motto-typed" aria-hidden="true">
              {display}
              {!reduceMotion && <span className="hero-caret" />}
            </span>
            <span className="hero-sr-only">{fullAnnouncement}</span>
          </h1>
          <p className="hero-lead">{t('hero.lead')}</p>
          <div className="hero-actions">
            <a href="#contact" className="hero-btn hero-btn--primary">
              {t('hero.ctaPrimary')}
            </a>
            <a href="#portfolio" className="hero-btn hero-btn--ghost">
              {t('hero.ctaSecondary')}
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Hero
